import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { ContextPreferenceIntroProfileStepV2Data, QuizScreenProps } from '@packages/shared/core/quiz/entities';
import { getZodiac } from '@packages/shared/core/user/store/selectors';

const goalToAchieveMap: Record<string, string> = {
  'find out about my ex': 'Find out about my ex',
  'give advice for my love life': 'Advice for my Love life',
  'give guidance on my future': 'Guidance on my future',
  'all above': 'Improve various life areas',

  // Experiment
  'get advice for my love life': 'Get advice for my love life',
  'receive guidance on my future': 'Receive guidance on my future',
  'explore my career path': 'Explore my career path',
  'get clarity through spirit guidance': 'Get clarity through spirit guidance',
  'achieve all of the above': 'Improve various areas of life',

  'find out if we can get back together': 'Find out if we can get back together',
  'know if my ex still has feelings': 'Know if my ex still has feelings',
  'see if my ex has someone else': 'See if my ex has someone else',
  'get closure and move on': 'Get closure and move on',
};

type ContextPreferenceIntroProfileStepV2Props = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ContextPreferenceIntroProfileStepV2 = ({ id, renderQuizScreen }: ContextPreferenceIntroProfileStepV2Props) => {
  const logger = useLogger();

  const { back, next, stepData, userPreferences } = useQuizStep(id);
  const zodiac = useSelector(getZodiac);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goal = userPreferences.goal;
  const goalToAchieve = goalToAchieveMap[goal] ?? 'Find out about my ex';

  const relationshipStatus = (userPreferences.relationshipStatus as string) || 'single';

  const goBack = async () => back();

  const onContinue = async () => {
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        zodiac: zodiac,
        goalToAchieve: goalToAchieve,
        relationshipStatus,
        ...(stepData as ContextPreferenceIntroProfileStepV2Data),
      })}
    </>
  );
};

export default ContextPreferenceIntroProfileStepV2;
